import { useCallback, useState, useRef } from 'react';
import { RingingDevice, BasicRingingDevice } from './RingingDevices';
import { LockAwareRingingDevice, RingingLock } from './RingingLock';
import tel03 from './tel03.mp3'; // free sound presented by http://www.kurage-kosho.info/

export function useRingingDevices() {
    const devices = useRef(new Map<string, RingingDevice>());
    const [lock] = useState<RingingLock>(new RingingLock());

    return {
        getRingingDevice: useCallback((tag: string) => {
            const existing = devices.current.get(tag);
            if (existing) return existing;
            const newDevice = new LockAwareRingingDevice(new BasicRingingDevice(tel03, tag), lock);
            devices.current.set(tag, newDevice);
            return newDevice;
        }, [devices, lock]),
    };
}
